export default __webpack_public_path__ + "static/media/bell.4c343ff7.svg";